<template>
  <div class="admin">
    <ReportTable />
  </div>
</template>

<script>
// @ is an alias to /src
import ReportTable from '@/components/Admin/DataTables/ReportTable.vue'

export default {
  name: 'Admin',
  components: {
    ReportTable
  }
}
</script>